import React from 'react';

import InternalDocs from '../Department/Documents/internal-docs';

import { StyledBoxInside, StyledTitleWidget } from './style';

import { OfertasComercialesBlanco } from '../../../../assets/images/index';
import { COMERCIALOFFER_FOLDER } from '../../../constants/folders';
import { COMERCIALOFFER_ID } from '../../../constants/associationId';

const ComercialOffers = () => (
  <StyledBoxInside>
    <StyledTitleWidget
      title="Ofertas comerciales"
      type="ranking"
      icon={OfertasComercialesBlanco}
      small
    />
    <InternalDocs
      rootFolderId={COMERCIALOFFER_FOLDER}
      associationId={COMERCIALOFFER_ID}
      bcreadcrumbTitle="Ofertas"
    />
  </StyledBoxInside>
);

export default ComercialOffers;
